import axios from "axios";

export default {
  getApiData({ getters, commit }) {
    return new Promise((resolve, reject) => {
      let userSuffix =
        getters.getPromoConfig.loggedIn || getters.getPromoConfig.isLoggedIn
          ? `&userid=${getters.getPromoConfig.customerId}`
          : "";
      axios
        .get(
          `https://api-mk.itsfogo.com/api/v1/pickyourteam/mypicks?label=${
            getters.getPromoConfig.label
          }&language=${getters.getPromoConfig.language}${userSuffix}`,
          {
            headers: {
              "x-bwin-session-token": getters.getPromoConfig.sessionToken,
              "x-bwin-user-token": getters.getPromoConfig.userToken
            }
          }
        )
        .then(response => {
          if (response.data.data.leagues.length > 0) {
            if (response.data.data.picks === null) {
              commit("setSelectedLeague", response.data.data.leagues[0].name);
              commit(
                "setDefaultLeagueTeam",
                response.data.data.leagues[0].teams
              );
              commit("setSelectedLeagueId", response.data.data.leagues[0].id);
            } else {
              commit("setSelectedLeague", response.data.data.leagues[0].name);
              commit(
                "setDefaultLeagueTeam",
                response.data.data.leagues[0].teams
              );
              commit(
                "setSelectedLeagueId",
                response.data.data.picks.domestic.leagueid
              );
            }
            commit("setLegueTabs", response.data.data.leagues);
            commit("setUserPick", response.data.data.picks);
            commit("setApiData", response.data.data);
            commit("setPromotionStatus", response.data.data.promotion_status);
            resolve();
          }
          reject();
        });
    });
  },
  sendLeagueData({ getters, commit }, team) {
    if (getters.getPromoConfig.loggedIn || getters.getPromoConfig.isLoggedIn) {
      const postData = {
        userid: getters.getPromoConfig.customerId,
        label: getters.getPromoConfig.label,
        language: getters.getPromoConfig.language,
        picks: {
          domestic: {
            leagueid: getters.getSelectedLeagueId,
            teamid: team.id
          }
        }
      };
      return new Promise(() => {
        axios
          .post(
            `https://api-mk.itsfogo.com/api/v1/pickyourteam/mypicks`,
            JSON.stringify(postData)
          )
          .then(() => {
            commit("setEditState", false);
            commit("setUserPick", postData.picks);
          });
      });
    }
  },
  getLeagueData({ getters, commit }) {
    const selectedLeagueId = getters.getLeagueViewData.find(
      item => item.id === getters.getSelectedLeagueId
    ).externalLeagueId;
    const language = getters.getPromoConfig.language;
    const lang = language === "en-uk" || language === "en_nl" ? "en" : language;
    return new Promise((resolve, reject) => {
      axios
        .get(
          `//stats.fn.sportradar.com/bwin/${lang}/Europe:Berlin/gismo/stats_season_tables/${selectedLeagueId}/0`
        )
        .then(response => {
          commit(
            "setLeagueTable",
            response.data.doc[0].data.tables[0].tablerows
          );
          resolve();
        })
        .catch(err => {
          console.error(err);
          reject();
        });
    });
  },
  getLeagueMatches({ getters, commit }) {
    const selectedLeagueFeedId = getters.getLeagueViewData.find(
      item => item.id === getters.getSelectedLeagueId
    ).feedId;
    return new Promise((resolve, reject) => {
      if (selectedLeagueFeedId === null) {
        reject(0);
      } else {
        axios
          .get(
            `//mediaserver.gvcaffiliates.com/feeds/${selectedLeagueFeedId}.json`
          )
          .then(response => {
            if (response.data.BettingOffer.League === undefined) {
              reject(0);
            } else {
              commit("setLeagueMatches", response.data.BettingOffer.League);
              resolve();
            }
          })
          .catch(err => {
            if (err === 0) {
              reject(0);
            } else {
              reject(1);
            }
          });
      }
    });
  }
};
